import { PhysicalSecurityFormDefinition } from '../models/form-definition';

export const PHYSICAL_SECURITY_FORM: PhysicalSecurityFormDefinition = {
  "key": "physical-security",
  "title": "MS Physical Security",
  "formType": "Forms_Authenticated_General",
  "sections": [
    {
      "key": "section-1",
      "title": "School Information",
      "fields": [
        {
          "key": "school_name",
          "type": "input",
          "label": "School Name:",
          "required": true
        },
        {
          "key": "school_address",
          "type": "address",
          "label": "School Address:",
          "required": true
        },
        {
          "key": "school_district",
          "type": "input",
          "label": "School District:",
          "required": true
        },
        {
          "key": "school_district_address",
          "type": "input",
          "label": "School District Address:",
          "required": true
        },
        {
          "key": "school_poc_name",
          "type": "input",
          "label": "School POC Name:",
          "required": true
        },
        {
          "key": "school_poc_number",
          "type": "phone",
          "label": "School POC Number:",
          "required": true
        }
      ]
    },
    {
      "key": "section-2",
      "title": "Access Control",
      "fields": [
        {
          "key": "facility_perimeter",
          "type": "radio",
          "label": "The facility perimeter and areas within the facility that require access control are well defined.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "facility_access",
          "type": "radio",
          "label": "The facility limits building access points.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "access_monitored",
          "type": "radio",
          "label": "Designated access points are monitored to control facility access.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "entry_control_system",
          "type": "radio",
          "label": "Positive entry control systems are established (e.g., telephone entry control, biometric access control).",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "signs",
          "type": "radio",
          "label": "Signs direct visitors to designated building entrances and exits.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "doors_secured",
          "type": "radio",
          "label": "Exterior doors to gyms, maintenance areas, kitchen, and delivery areas are secured when not in use.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "visitor_check_in",
          "type": "radio",
          "label": "Visitors are required to check in with the front office upon arrival and departure.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "visitor_id",
          "type": "radio",
          "label": "Visitors are provided with school issued identification badges when on school grounds.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "policies",
          "type": "radio",
          "label": "Policies are in place for those with and without appointments or official school business.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "vendors_contractors",
          "type": "radio",
          "label": "Vendors and contractor personnel are escorted throughout the facility.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "background_check",
          "type": "radio",
          "label": "Background checks are conducted on all school employees, vendors, and contractors.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "key_control",
          "type": "radio",
          "label": "A key control program is established that monitors keys, entry cards, and duplicates.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "key_control_audit",
          "type": "radio",
          "label": "Key control program is audited annually.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        }
      ]
    },
    {
      "key": "section-3",
      "title": "Building Exterior",
      "fields": [
        {
          "key": "bus_loading_zones",
          "type": "radio",
          "label": "Policies are in place that restrict access to bus-loading zones.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "zones_marked",
          "type": "radio",
          "label": "Bus-loading, unloading, drop off zones and fire zones are clearly marked.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "designated_parking_lots",
          "type": "radio",
          "label": "School designates areas for use of parking lots (e.g., staff lot, student lot, visitor spaces).",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "parking_id",
          "type": "radio",
          "label": "Parking system incorporates an identification system (e.g., placards in windshields).",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "perimeter_barriers",
          "type": "radio",
          "label": "Appropriate perimeter barriers or gates are installed and secured when not in use.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "perimeter_barriers_monitoring",
          "type": "radio",
          "label": "Perimeter barriers are clear to enable continuous monitoring and to inhibit concealment of people or packages.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "windows_locked",
          "type": "radio",
          "label": "Windows are locked securely.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "window_hardware",
          "type": "radio",
          "label": "Window hardware and frames are regularly inspected for security weaknesses.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "visual_surveillance",
          "type": "radio",
          "label": "Facility has visual surveillance capability (e.g., designated surveillance points, cleared lines of sight).",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "clear_zones",
          "type": "radio",
          "label": "Clear zones adjacent to buildings are free of vegetation and other obstructions.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "barriers",
          "type": "radio",
          "label": "Barriers are installed to protect doors and windows from small arms fire and explosive blast effects.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "grounds_lit",
          "type": "radio",
          "label": "School grounds are adequately lit.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "vandalism_graffiti",
          "type": "radio",
          "label": "Vandalism and graffiti is documented and removed.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "equipment_protective_enclosure",
          "type": "radio",
          "label": "Mechanical, electrical, and other equipment are surrounded by protective enclosures to prevent unauthorized access.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "access_roof",
          "type": "radio",
          "label": "Access to the roof is restricted.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "speed_limits",
          "type": "radio",
          "label": "Speed limits are posted.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "walkways_lit",
          "type": "radio",
          "label": "Covered walkways are adequately lit to ensure visual surveillance.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "fire_hydrants",
          "type": "radio",
          "label": "Fire hydrants are clearly visible.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        }
      ]
    },
    {
      "key": "section-4",
      "title": "Building Interior",
      "fields": [
        {
          "key": "front_office",
          "type": "radio",
          "label": "School front office is clearly marked.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "first_aid_nurse",
          "type": "radio",
          "label": "First aid/school nurse office location is clearly marked.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "utility_secure",
          "type": "radio",
          "label": "Critical utility systems and equipment are secured and locked.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "employee_shut_off",
          "type": "radio",
          "label": "Employees are familiar and trained with how to shut off utility services",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "inventory_chemicals",
          "type": "radio",
          "label": "A positive inventory is kept on chemicals in use or used in science classes or laboratory areas.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "roof_access_secure",
          "type": "radio",
          "label": "Roof access doors are secured and locked",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "custodial_secured",
          "type": "radio",
          "label": "Custodial and storage closets are secured and locked.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "trashcans_minimized",
          "type": "radio",
          "label": "The number of containers and trashcans in hallways, atriums, and lobby areas are minimized.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "unassigned_lockers",
          "type": "radio",
          "label": "Unassigned lockers are secured.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "doors_numbered",
          "type": "radio",
          "label": "Doors and stairwells are numbered.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "stairwell_lit",
          "type": "radio",
          "label": "Stairwells, hallways, and restrooms are adequately lit.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "stairwell_monitored",
          "type": "radio",
          "label": "Enclosed stairwells are monitored, either electronically or by security personnel.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "smoke_detector_vandal",
          "type": "radio",
          "label": "Smoke detectors have vandal-resistant features (e.g., tamper alarms or protective cages).",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "doors_locks",
          "type": "radio",
          "label": "Doors and locks are in good condition.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "access_fire_extinguishers",
          "type": "radio",
          "label": "Easy access to fire extinguishers.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "access_first_aid",
          "type": "radio",
          "label": "Adequate access to first aid supplies (e.g., automated external defibrillators (AEDs)). ",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "fire_doors",
          "type": "radio",
          "label": "Class III type fire doors with crash bar capabilities and automatic activation are installed.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "retention_film",
          "type": "radio",
          "label": "Blast fragment retention film is on windows.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        }
      ]
    },
    {
      "key": "section-5",
      "title": "Classroom Security",
      "fields": [
        {
          "key": "classroom_safe_zones",
          "type": "radio",
          "label": "Classroom safe zones or protection areas are established.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "classroom_two_way_communication",
          "type": "radio",
          "label": "Classroom has access to two-way communication system.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "classroom_visible",
          "type": "radio",
          "label": "All areas of the classroom are visible from the classroom door.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "classroom_locked_inside",
          "type": "radio",
          "label": "Classroom doors can be locked from the inside.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "classroom_door_windows",
          "type": "radio",
          "label": "Classroom doors with windows can be covered.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "classroom_aisle_space",
          "type": "radio",
          "label": "Classrooms have adequate aisle space for quick exits.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "class_rosters",
          "type": "radio",
          "label": "Class rosters are reviewed and updated on a regular basis.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "classroom_locked",
          "type": "radio",
          "label": "Faculty and staff are assigned to check that all classrooms and bathrooms are locked after the school day.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "valuables_secure",
          "type": "radio",
          "label": "Valuable items are secured (e.g., instruments, computers, video equipment).",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "chemicals_stored",
          "type": "radio",
          "label": "Chemicals, poisons, and flammable materials are properly secured and stored.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "fire_extinguishers_inspected",
          "type": "radio",
          "label": "Fire extinguishers are inspected on an annual basis.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "hazardous_material_training",
          "type": "radio",
          "label": "Personnel working with hazardous materials have received appropriate training.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        }
      ]
    },
    {
      "key": "section-6",
      "title": "School Culture",
      "fields": [
        {
          "key": "security_information_training",
          "type": "radio",
          "label": "Faculty, students, and staff are all provided with security information and training.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "first_responders",
          "type": "radio",
          "label": "Security information and training includes information on how first responders operate to avoid hindering operations.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "suspicious_packages",
          "type": "radio",
          "label": "Security information and training includes training on how to identify suspicious packages.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "suspicious_calls",
          "type": "radio",
          "label": "Faculty and staff have been trained to appropriately respond to and report threatening/suspicious phone calls.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "monitoring",
          "type": "radio",
          "label": "Faculty and staff monitor hallways, stairwells, and restrooms during school hours.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "student_access",
          "type": "radio",
          "label": "Students do not have access to the school without direct staff supervision.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "harmful_behaviour",
          "type": "radio",
          "label": "Curricula and programs aimed at preventing harmful behaviors are implemented (e.g., social problem-solving, life skills, anti-bullying, mentoring programs, character education).",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "code_of_conduct_review",
          "type": "radio",
          "label": "School maintains, reviews, and updates a code of conduct/school handbook.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "code_of_conduct_crime",
          "type": "radio",
          "label": "Code of conduct/school handbook contains standard definitions and procedures that identify school crime.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "mental_health_services",
          "type": "radio",
          "label": "School has a well-developed network of service providers that students can be referred to (e.g., mental health services)",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "photo_identification",
          "type": "radio",
          "label": "Photo identification badges are issued to all faculty, students, and staff.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        }
      ]
    },
    {
      "key": "section-7",
      "title": "Communication Systems",
      "fields": [
        {
          "key": "installed_two_way_communication",
          "type": "radio",
          "label": "Systems are installed that provide two- way communication between faculty, staff, administrators, and security personnel.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "communication_system",
          "type": "radio",
          "label": "Communication system is installed that provides communication with all people at the school, including faculty, students, staff, emergency response teams, and visitors.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "communication_law_emergency",
          "type": "radio",
          "label": "Regular communication with local law enforcement and emergency responders is established.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "communication_public",
          "type": "radio",
          "label": "Procedures are developed for communicating with public and the media regarding security issues.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "notification_protocol",
          "type": "radio",
          "label": "A notification protocol is developed that outlines who should be contacted in emergencies and how.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        }
      ]
    },
    {
      "key": "section-8",
      "title": "Reporting Procedures",
      "fields": [
        {
          "key": "point_of_contact_threats",
          "type": "radio",
          "label": "School has a single point of contact for reporting threats, threatening behavior, or concerning behavior.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "point_of_contact_available",
          "type": "radio",
          "label": "The identified point of contact for reporting potential threats is available 24/7.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "multiple_ways_reach_poc",
          "type": "radio",
          "label": "There are multiple ways someone can reach the point of contact for reporting potential threats (e.g., email, telephone, online, in-person).",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "reporting_anonymous",
          "type": "radio",
          "label": "Reporting can be anonymous.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "policy_threatening_situation",
          "type": "radio",
          "label": "There are clear policies in place for collecting and acting on information about a threatening or potentially threatening situation.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "policy_confidentially",
          "type": "radio",
          "label": "Policies explain how information will be handled confidentially and appropriately.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        }
      ]
    },
    {
      "key": "section-9",
      "title": "Security Equipment",
      "fields": [
        {
          "key": "security_system",
          "type": "radio",
          "label": "Facility has security system installed (e.g., CCTV, IP cameras, digital camera integration and intrusion detection and alarm system).",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "video_security_power",
          "type": "radio",
          "label": "Video security systems are connected to the building’s emergency power supply.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "alarm_law_enforecment",
          "type": "radio",
          "label": "Alarm system is connected to local law enforcement.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "security_tapes_recording",
          "type": "radio",
          "label": "Security camera tapes or recordings are retained for an allotted time period.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "emergency_equipment_checked",
          "type": "radio",
          "label": "All emergency response equipment and supplies are checked on a regular basis.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "utility_service_capability",
          "type": "radio",
          "label": "School has adequate utility service capability to meet normal and emergency needs.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "metal_detectors",
          "type": "radio",
          "label": "Magnetometers (metal detectors) and x-ray equipment are installed.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        }
      ]
    },
    {
      "key": "section-10",
      "title": "Security Personnel",
      "fields": [
        {
          "key": "security_director_coordinate",
          "type": "radio",
          "label": "A school security director is designated to develop, implement, and coordinate all security-related activities.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "armed_police",
          "type": "radio",
          "label": "School security personnel include an armed trained police officer or school resource officer.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "security_single_school",
          "type": "radio",
          "label": "School security personnel are stationed at a single school.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "security_visible",
          "type": "radio",
          "label": "School security personnel are a visible and regular presence during school hours of operation.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "security_deployed",
          "type": "radio",
          "label": "School security personnel are deployed during normal school hours of operation and special events.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "security_vehicles",
          "type": "radio",
          "label": "Security personnel check for unauthorized vehicles in parking lots or on school grounds.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "commons_monitored",
          "type": "radio",
          "label": "Halls, common areas, and gyms are monitored for suspicious items (e.g., backpacks, briefcases, boxes).",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "security_sensitive_areas",
          "type": "radio",
          "label": "Security personnel are deployed to assigned areas to regularly inspect sensitive or critical areas (e.g., auditoriums or under stages where items such as weapons or explosive materials can be hidden).",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "faculty_staff_monitor",
          "type": "radio",
          "label": "Faculty and staff monitor hallways, stairwells, and restrooms during school hours.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "security_doors",
          "type": "radio",
          "label": "Security personnel regularly inspect and secure doors.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "after_hours_security",
          "type": "radio",
          "label": "If the building is used after school hours, security personnel are present.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "safety_audits",
          "type": "radio",
          "label": "School safety audits are conducted on a regular or continuing basis.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        }
      ]
    },
    {
      "key": "section-11",
      "title": "Cybersecurity",
      "fields": [
        {
          "key": "computer_staff",
          "type": "radio",
          "label": "School maintains a well-trained computer security staff.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "staff_password",
          "type": "radio",
          "label": "School faculty and staff are required to use passwords and unique login information to access electronic files.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "student_password",
          "type": "radio",
          "label": "Students are required to use passwords and unique login information to access electronic files.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "security_plans",
          "type": "radio",
          "label": "Security plans for computer and information systems are established.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "security_hardware_software",
          "type": "radio",
          "label": "These computer and information system security systems include both hardware and software.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "staff_secure_computer",
          "type": "radio",
          "label": "Faculty and staff are trained in safe and secure computer use.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "students_secure_computer",
          "type": "radio",
          "label": "Students are trained in safe and secure computer use.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "cyersecurity_cyberbullying",
          "type": "radio",
          "label": "Cybersafety and cyberbullying programs are provided for students.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "computer_filters",
          "type": "radio",
          "label": "Computers include filters to monitor internet activity on school computers.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "video_security",
          "type": "radio",
          "label": "Video security system is adequately protected against hackers.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        }
      ]
    },
    {
      "key": "section-12",
      "title": "Emergency Operations Plans",
      "fields": [
        {
          "key": "comprehensive_eop",
          "type": "radio",
          "label": "A comprehensive school emergency operations plan has been developed.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "community_partners",
          "type": "radio",
          "label": "Plan has been developed in coordination with community partners (e.g., local law enforcement, emergency medical personnel, and fire department personnel)",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "numerous_circumstances",
          "type": "radio",
          "label": "Plan takes into consideration numerous circumstances and criteria for response (e.g., lockdown, evacuation, shelter-in-place).",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "floor_plan",
          "type": "radio",
          "label": "Plan contains an updated map of the school’s floor plan that includes room numbers, evacuation routes, and utility shut offs.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "roles_responsibilites",
          "type": "radio",
          "label": "Plan defines roles and responsibilities—that is, creates an organizational system (e.g., school security commander, public information officer, etc.) *Consider following Incident Command System (ICS) structure",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "reporting_incidents_internally",
          "type": "radio",
          "label": "Plan contains a method for reporting incidents internally to faculty, students, and staff (e.g., mass notification system). ",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "reporting_incidents_externally",
          "type": "radio",
          "label": "Plan contains a method for reporting incidents externally to media, families, neighbors, and the community.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "plan_disabilites",
          "type": "radio",
          "label": "Plan contains directions that provide for the needs of students, staff, and visitors with disabilities and other functional and access needs.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "equipment_supplies",
          "type": "radio",
          "label": "Plan considers necessary equipment and supplies to respond to a crisis.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "vocabulary",
          "type": "radio",
          "label": "Plan contains common vocabulary.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "accountability",
          "type": "radio",
          "label": "Plan includes an accountability system that accounts for all faculty, students, staff, and visitors.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "parent_reunification",
          "type": "radio",
          "label": "Plan contains a parent reunification system that ensures students are only released to authorized individuals after an incident.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "checklist_incident",
          "type": "radio",
          "label": "Plan contains action checklists for teachers, administrative staff, and other staff located throughout the school to follow during incident response.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "post_recovery_response",
          "type": "radio",
          "label": "Plan includes components for post-incident response/recovery (e.g., stress management, mental health services, infrastructure restoration, post-incident evaluation, business continuity plans etc.)",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "plan_review",
          "type": "radio",
          "label": "Plan is reviewed and updated on an annual basis.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "exercise_drills",
          "type": "radio",
          "label": "School conducts regular exercises/drills of emergency plans.",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "threat_assessment_team",
          "type": "radio",
          "label": "Does your school have a threat assessment team?",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "who_threat_assessment_team",
          "type": "multicheckbox",
          "label": "Who is on the threat assessment team?",
          "description": "Check all that apply",
          "required": false,
          "hideExpression": "model.threat_assessment_team !== 'Yes'",
          "options": [
            {
              "value": "Member(s) of the faculty",
              "label": "Member(s) of the faculty"
            },
            {
              "value": "Member(s) of the staff",
              "label": "Member(s) of the staff"
            },
            {
              "value": "Member(s) of the administration",
              "label": "Member(s) of the administration"
            },
            {
              "value": "Investigator(s) (e.g., school resource officer, other police officer assigned to the school)",
              "label": "Investigator(s) (e.g., school resource officer, other police officer assigned to the school)"
            },
            {
              "value": "Mental health professional(s) (e.g., school psychologist, clinical psychologist, forensic psychologist)",
              "label": "Mental health professional(s) (e.g., school psychologist, clinical psychologist, forensic psychologist)"
            },
            {
              "value": "Guidance counselor(s)",
              "label": "Guidance counselor(s)"
            },
            {
              "value": "Teachers",
              "label": "Teachers"
            },
            {
              "value": "Coaches",
              "label": "Coaches"
            },
            {
              "value": "Ad hoc members selected to sit on the team on a case-by-case basis because they knew the student in question",
              "label": "Ad hoc members selected to sit on the team on a case-by-case basis because they knew the student in question"
            },
            {
              "value": "Other",
              "label": "Other"
            }
          ]
        },
        {
          "key": "other_threat_team",
          "type": "repeat",
          "label": "Threat Assessment Team Members (Other)",
          "required": false,
          "hideExpression": "model.who_threat_assessment_team?.['Other'] !== true"
        },
        {
          "key": "threat_team_rotate",
          "type": "radio",
          "label": "Do members of the threat assessment team rotate?",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "threat_assessment_team_rotate",
          "type": "multicheckbox",
          "label": "If yes, how often do they rotate? (Check all that apply)",
          "description": "Check all that apply",
          "required": false,
          "hideExpression": "model.threat_team_rotate !== 'Yes'",
          "options": [
            {
              "value": "Weekly",
              "label": "Weekly"
            },
            {
              "value": "Monthly",
              "label": "Monthly"
            },
            {
              "value": "Quarterly",
              "label": "Quarterly"
            },
            {
              "value": "Yearly",
              "label": "Yearly"
            },
            {
              "value": "Other",
              "label": "Other"
            }
          ]
        },
        {
          "key": "threat_team_rotate_when",
          "type": "repeat",
          "label": "Other, how often do they rotate",
          "required": false,
          "hideExpression": "model.threat_assessment_team_rotate?.['Other'] !== true"
        },
        {
          "key": "threat_team_training",
          "type": "radio",
          "label": "Does the threat assessment team receive training?",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "threat_team_training_often",
          "type": "radio",
          "label": "If yes, how often do they receive training? (Check one)",
          "description": "Check one",
          "required": false,
          "hideExpression": "model.threat_team_training !== 'Yes'",
          "options": [
            {
              "value": "Weekly",
              "label": "Weekly"
            },
            {
              "value": "Monthly",
              "label": "Monthly"
            },
            {
              "value": "Quarterly",
              "label": "Quarterly"
            },
            {
              "value": "Yearly",
              "label": "Yearly"
            },
            {
              "value": "Other",
              "label": "Other"
            }
          ]
        },
        {
          "key": "threat_team_training_when",
          "type": "repeat",
          "label": "Other, how often do they recieve training?",
          "required": false,
          "hideExpression": "model.threat_team_training_often !== 'Other'"
        },
        {
          "key": "threat_assessment_trainings",
          "type": "multicheckbox",
          "label": "What topics are covered in threat assessment team trainings (Check all that apply)",
          "description": "Check all that apply",
          "required": false,
          "hideExpression": "model.threat_team_training !== 'Yes'",
          "options": [
            {
              "value": "Public Awareness",
              "label": "Public Awareness"
            },
            {
              "value": "Threat Management",
              "label": "Threat Management"
            },
            {
              "value": "Threat Investigations",
              "label": "Threat Investigations"
            },
            {
              "value": "Prevention",
              "label": "Prevention"
            },
            {
              "value": "Mental Health Concerns",
              "label": "Mental Health Concerns "
            },
            {
              "value": "Legal/Policy Concerns",
              "label": "Legal/Policy Concerns"
            },
            {
              "value": "Privacy Concerns",
              "label": "Privacy Concerns"
            },
            {
              "value": "Other",
              "label": "Other (please specify)"
            }
          ]
        },
        {
          "key": "training_topics_covered_other",
          "type": "repeat",
          "label": "Other trainings",
          "required": false,
          "hideExpression": "model.threat_assessment_trainings?.['Other'] !== true"
        },
        {
          "key": "threat_assessment_conducted",
          "type": "multicheckbox",
          "label": "How are threat assessment trainings conducted? (Check all that apply)",
          "description": "Check all that apply",
          "required": false,
          "hideExpression": "model.threat_team_training !== 'Yes'",
          "options": [
            {
              "value": "Presentations",
              "label": "Presentations"
            },
            {
              "value": "Hands on experience/role playing/scenarios",
              "label": "Hands on experience/role playing/scenarios"
            },
            {
              "value": "Other",
              "label": "Other (please specify)"
            }
          ]
        },
        {
          "key": "training_topics_conducted_other",
          "type": "repeat",
          "label": "Other, threat trainings conducted",
          "required": false,
          "hideExpression": "model.threat_assessment_conducted?.['Other'] !== true"
        },
        {
          "key": "single_poc",
          "type": "radio",
          "label": "Does your school have a single point of contact (phone number, email address, etc.) for reporting threats, threatening behavior, or concerning behavior?",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "poc_available",
          "type": "radio",
          "label": "If yes, is this point of contact for reporting potential threats available 24/7?",
          "required": false,
          "hideExpression": "model.single_poc !== 'Yes'",
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "poc_reach",
          "type": "multicheckbox",
          "label": "What are the ways someone can reach the point of contact for reporting potential threats? (Check all that apply)",
          "description": "Check all that apply",
          "required": false,
          "hideExpression": "model.single_poc !== 'Yes'",
          "options": [
            {
              "value": "Email",
              "label": "Email"
            },
            {
              "value": "Telephone",
              "label": "Telephone"
            },
            {
              "value": "In person",
              "label": "In person"
            },
            {
              "value": "Online",
              "label": "Online"
            },
            {
              "value": "Other",
              "label": "Other"
            }
          ]
        },
        {
          "key": "poc_reach_other",
          "type": "repeat",
          "label": "Other ways to reach point of contact?",
          "required": false,
          "hideExpression": "model.poc_reach?.['Other'] !== true"
        },
        {
          "key": "poc_single_multiple",
          "type": "radio",
          "label": "If there is a central point of contact for reporting potential threats, does one person manage this point of contact or does a group manage it? (Check one)",
          "description": "Check one",
          "required": false,
          "options": [
            {
              "value": "One person manages the point of contact",
              "label": "One person manages the point of contact"
            },
            {
              "value": "A group manages the point of contact",
              "label": "A group manages the point of contact"
            },
            {
              "value": "There is no central point of contact",
              "label": "There is no central point of contact"
            }
          ]
        },
        {
          "key": "poc_rotate",
          "type": "radio",
          "label": "Is this point of contact for reporting potential threats available 24/7?",
          "required": false,
          "hideExpression": "model.poc_single_multiple !== 'One person manages the point of contact'",
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "poc_often_rotate",
          "type": "radio",
          "label": "How often does this person rotate? (Check one)",
          "description": "Check one",
          "required": false,
          "hideExpression": "model.poc_single_multiple !== 'One person manages the point of contact'",
          "options": [
            {
              "value": "Weekly",
              "label": "Weekly"
            },
            {
              "value": "Monthly",
              "label": "Monthly"
            },
            {
              "value": "Quarterly",
              "label": "Quarterly"
            },
            {
              "value": "Yearly",
              "label": "Yearly"
            },
            {
              "value": "Other",
              "label": "Other (please specify)"
            }
          ]
        },
        {
          "key": "poc_often_rotate_other",
          "type": "input",
          "label": "Other, how often does the person rotate?",
          "required": false,
          "hideExpression": "!model.poc_often_rotate?.includes('Other')"
        },
        {
          "key": "threat_policies",
          "type": "radio",
          "label": "Does the threat assessment team have clear policies in place for collecting and acting on information about a threatening or potentially threatening situation?",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "threat_policy_information",
          "type": "multicheckbox",
          "label": "Does the policy about threat assessment inquiries include information on the following: (Check all that apply)",
          "description": "Check all that apply",
          "required": false,
          "hideExpression": "model.threat_policies !== 'Yes'",
          "options": [
            {
              "value": "Purpose and scope of the policy",
              "label": "Purpose and scope of the policy"
            },
            {
              "value": "Role of educators and threat assessment in relation to the role of law enforcement officials",
              "label": "Role of educators and threat assessment in relation to the role of law enforcement officials"
            },
            {
              "value": "Identity of and delegation of authority to school officials concerning determination that a threat assessment inquiry or investigation should be pursued",
              "label": "Identity of and delegation of authority to school officials concerning determination that a threat assessment inquiry or investigation should be pursued"
            },
            {
              "value": "Definition of the threshold of concern for initiating inquiry or investigation",
              "label": "Definition of the threshold of concern for initiating inquiry or investigation"
            },
            {
              "value": "Types of information that can/should be gathered during a threat assessment inquiry or investigation",
              "label": "Types of information that can/should be gathered during a threat assessment inquiry or investigation"
            },
            {
              "value": "Designation of an individual or group responsible for gathering and analyzing information on groups/individuals",
              "label": "Designation of an individual or group responsible for gathering and analyzing information on groups/individuals"
            },
            {
              "value": "Steps or procedures that should be followed from initiation to completion of the threat assessment inquiry",
              "label": "Steps or procedures that should be followed from initiation to completion of the threat assessment inquiry"
            }
          ]
        },
        {
          "key": "policy_behavior",
          "type": "radio",
          "label": "Does the policy specify certain behaviors of concern or provide examples of behaviors that would merit a referral to the threat assessment team?",
          "required": false,
          "hideExpression": "model.threat_policies !== 'Yes'",
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "policy_behavior_other",
          "type": "repeat",
          "label": "If yes, list those behaviors that would merit a referral to the threat assessment team",
          "required": false,
          "hideExpression": "model.policy_behavior !=='Yes'"
        },
        {
          "key": "information_gathered_inquiry",
          "type": "multicheckbox",
          "label": "What types of information are generally gathered during an inquiry: (Check all that apply)",
          "description": "Check all that apply",
          "required": false,
          "options": [
            {
              "value": "Facts that drew attention to the student, situation, or target",
              "label": "Facts that drew attention to the student, situation, or target"
            },
            {
              "value": "Information about the student",
              "label": "Information about the student"
            },
            {
              "value": "Identifying information",
              "label": "Identifying information"
            },
            {
              "value": "Background information",
              "label": "Background information"
            },
            {
              "value": "Current life information",
              "label": "Current life information"
            },
            {
              "value": "Information about attack related behaviors in which the student has engaged",
              "label": "Information about attack related behaviors in which the student has engaged"
            },
            {
              "value": "The student’s motives",
              "label": "The student’s motives"
            },
            {
              "value": "The targets that are in danger of violence",
              "label": "The targets that are in danger of violence"
            },
            {
              "value": "None of the above",
              "label": "None of the above"
            },
            {
              "value": "Other",
              "label": "Other (please specify)"
            }
          ]
        },
        {
          "key": "information_gathered_inquiry_other",
          "type": "repeat",
          "label": "Other, information gathered?",
          "required": false,
          "hideExpression": "model.information_gathered_inquiry?.['Other'] !== true"
        },
        {
          "key": "assessment_team_encourage",
          "type": "multicheckbox",
          "label": "How does the threat assessment team actively encourage school community members (students, parents, faculty, staff, administrators, etc.) to report knowledge of potential threats? (Check all that apply)",
          "description": "Check all that apply",
          "required": true,
          "options": [
            {
              "value": "Public awareness campaigns (posters, announcements)",
              "label": "Public awareness campaigns (posters, announcements)"
            },
            {
              "value": "Student assemblies",
              "label": "Student assemblies"
            },
            {
              "value": "In-class lectures/presentations",
              "label": "In-class lectures/presentations"
            },
            {
              "value": "Student-teacher conferences",
              "label": "Student-teacher conferences"
            },
            {
              "value": "Parent-teacher conferences",
              "label": "Parent-teacher conferences"
            },
            {
              "value": "Newsletters",
              "label": "Newsletters"
            },
            {
              "value": "Other",
              "label": "Other (please specify)"
            }
          ]
        },
        {
          "key": "assessment_team_encourage_other",
          "type": "repeat",
          "label": "Other, how does the threat assessment team actively encourage school community members (students, parents, faculty, staff, administrators, etc.) to report knowledge of potential threats? ",
          "required": false,
          "hideExpression": "model.assessment_team_encourage?.['Other'] !== true"
        },
        {
          "key": "assessment_team_inquiry",
          "type": "multicheckbox",
          "label": "How does the threat assessment team make school community members (students, parents, faculty, staff, administrators, etc.) aware of the general steps and timeline of the inquiry process? (Check all that apply)",
          "description": "Check all that apply",
          "required": true,
          "options": [
            {
              "value": "Public awareness campaigns (posters, announcements)",
              "label": "Public awareness campaigns (posters, announcements)"
            },
            {
              "value": "Student assemblies",
              "label": "Student assemblies"
            },
            {
              "value": "In-class lectures/presentations",
              "label": "In-class lectures/presentations"
            },
            {
              "value": "Student-teacher conferences",
              "label": "Student-teacher conferences"
            },
            {
              "value": "Parent-teacher conferences",
              "label": "Parent-teacher conferences"
            },
            {
              "value": "Newsletters",
              "label": "Newsletters"
            },
            {
              "value": "Other",
              "label": "Other (please specify)"
            }
          ]
        },
        {
          "key": "assessment_team_inquiry_other",
          "type": "repeat",
          "label": "Other, How does the threat assessment team make school community members (students, parents, faculty, staff, administrators, etc.) aware of the general steps and timeline of the inquiry process?",
          "required": false,
          "hideExpression": "model.assessment_team_inquiry?.['Other'] !== true"
        },
        {
          "key": "assessment_team_confidentially",
          "type": "radio",
          "label": "Does the threat assessment team explain how information will be handled confidentially and appropriately?",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        }
      ]
    },
    {
      "key": "section-13",
      "title": "General LLE Support - Local Law Enforcement Support",
      "fields": [
        {
          "key": "name_LE",
          "type": "input",
          "label": "Name of LE Agency",
          "required": true
        },
        {
          "key": "address_LE",
          "type": "address",
          "label": "Address of LE Agency:",
          "required": true
        },
        {
          "key": "agency_poc",
          "type": "input",
          "label": "Agency  POC:",
          "required": true
        },
        {
          "key": "size_force",
          "type": "input",
          "label": "Size of Force:",
          "required": true
        },
        {
          "key": "response_time",
          "type": "input",
          "label": "Estimated Response Time to school:",
          "required": true
        },
        {
          "key": "patrols",
          "type": "radio",
          "label": "Is the area around the school regularly patrolled by officers on vehicle or foot?",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "patrols_how_often",
          "type": "input",
          "label": "If so, how often?",
          "required": false,
          "hideExpression": "model.patrols !== 'Yes'"
        },
        {
          "key": "cbrne_environment",
          "type": "radio",
          "label": "Ability to Operate in a CBRNE Environment",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "cbrne_environment_limitations",
          "type": "textarea",
          "label": "Please address capabilities or limitations in this area:",
          "required": false,
          "hideExpression": "model.cbrne_environment !== 'Yes'"
        },
        {
          "key": "mutual_aid",
          "type": "radio",
          "label": "Mutual Aid Agreements",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "mutual_aid_describe",
          "type": "textarea",
          "label": "If yes, please describe",
          "required": false,
          "hideExpression": "model.mutual_aid !== 'Yes'"
        },
        {
          "key": "participation_trainings",
          "type": "radio",
          "label": "Participation in Visits/Exercises/ Training Affecting This Site",
          "required": true,
          "options": [
            {
              "value": "Yes",
              "label": "Yes"
            },
            {
              "value": "No",
              "label": "No"
            }
          ]
        },
        {
          "key": "participation_trainings_describe",
          "type": "textarea",
          "label": "If yes, please describe",
          "required": false,
          "hideExpression": "model.participation_trainings !== 'Yes'"
        },
        {
          "key": "training_gaps",
          "type": "multicheckbox",
          "label": "Training Gaps",
          "description": "Areas of Need",
          "required": true,
          "options": [
            {
              "value": "Active Shooter",
              "label": "Active Shooter"
            },
            {
              "value": "Mental Health",
              "label": "Mental Health"
            },
            {
              "value": "Bomb Threats",
              "label": "Bomb Threats"
            },
            {
              "value": "K-9 support",
              "label": "K-9 support"
            },
            {
              "value": "Surveillance Detection",
              "label": "Surveillance Detection"
            },
            {
              "value": "Other",
              "label": "Other (Please Describe)"
            }
          ]
        },
        {
          "key": "training_gaps_other",
          "type": "textarea",
          "label": "Other, please describe",
          "required": false,
          "hideExpression": "model.training_gaps?.['Other'] !== true"
        },
        {
          "key": "personal_gaps",
          "type": "input",
          "label": "Personal Gaps (Areas of Need):",
          "required": true
        },
        {
          "key": "comments_subject_site",
          "type": "input",
          "label": "Comments on Protection and Prevention Role Related to Subject Site:",
          "required": true
        }
      ]
    }
  ]
} as const;
